import "./styles.css";
import QueueDashboard from "./queueDashboard";
import React, { useEffect, useState } from "react";
import { GetQueueDashboards, QueueSummaryDTO } from "./tenantApiCalls";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import { getPreference, iPreference, savePrefence } from "../../../interfaces/preference";
import { sortByField } from "../../../utilities/sort";
import useInterval from "../../../hooks/useInterval";
import { getExpandedDashboards, saveExpandedDashboards } from "../../../utilities/localStore/calls";

export interface QueueDashboardPM extends QueueSummaryDTO {
    name: string;
    pinned: boolean;
    expanded: boolean;
}

function Index() {
    const UserInfo = useSelector((state: RootState) => state.UserInformation);
    const [pinnedDashboards, setPinnedDashboards] = React.useState<Array<QueueDashboardPM>>([]);
    const [unPinnedDashboards, setUnPinnedDashboards] = React.useState<Array<QueueDashboardPM>>([]);

    useEffect(() => {
        (async () => {
            getMailBoxData();
        })();
    }, []);

    const getMailBoxData = async () => {
        const q_results = await GetQueueDashboards();
        const data = q_results.data;
        if (!data || !q_results.isOk) return;
        let expandedDashboards = getExpandedDashboards();
        let dashboards = UserInfo.mailboxes.map(x => {
            let mailbox = data.items.find(c => c.id == x.id);
            if (mailbox) {
                return {
                    ...mailbox,
                    name: x.name,
                    expanded: expandedDashboards.has(x.id),
                    pinned: false,
                };
            }
            return {
                name: x.name,
                id: x.id,
                countBySLA: {},
                countByStatus: {},
                expanded: expandedDashboards.has(x.id),
                pinned: false,
            };
        });

        let PinnedDashboardIds = getPreference().pinnedDashboardIds;
        let sortedPinned: QueueDashboardPM[] = [];
        PinnedDashboardIds.forEach(x => {
            let mappedQ = dashboards.find(c => c.id == x);
            if (mappedQ) {
                mappedQ.pinned = true;
                sortedPinned.push(mappedQ);
            }
        });

        let sortedUnPinned = dashboards.filter(x => x.id !== PinnedDashboardIds.find(y => y == x.id));
        sortedUnPinned = sortByField(sortedUnPinned, "name", false);
        setPinnedDashboards(sortedPinned);
        setUnPinnedDashboards(sortedUnPinned);
    };

    useInterval(getMailBoxData, 30 * 1000);

    function onPinTableChange(id: number, isPinned: boolean) {
        let preference: iPreference = getPreference();
        let pinned = [...pinnedDashboards];
        let notPinned = [...unPinnedDashboards];
        if (isPinned) {
            preference.pinnedDashboardIds.push(id);
            let mappedQ = unPinnedDashboards.find(c => c.id == id);
            if (mappedQ) {
                mappedQ.pinned = true;
                pinned.push(mappedQ);
                notPinned = notPinned.filter(x => x.id != id);
            }
        } else {
            preference.pinnedDashboardIds = preference.pinnedDashboardIds.filter(x => x != id);
            let removedPinQ = pinnedDashboards.find(x => x.id == id);
            if (removedPinQ) {
                removedPinQ.pinned = false;
                notPinned.push(removedPinQ);
                pinned = pinned.filter(x => x.id != id);
            }
            notPinned = sortByField(notPinned, "name", false);
        }
        setPinnedDashboards(pinned);
        setUnPinnedDashboards(notPinned);
        savePrefence(preference);
    }

    function hideShowTable(id: number) {
        let expandedDashboards = getExpandedDashboards();
        let expandedValue = true;
        if (expandedDashboards.has(id)) {
            expandedDashboards.delete(id);
            expandedValue = false;
        } else {
            expandedDashboards.add(id);
        }
        saveExpandedDashboards(expandedDashboards);

        let mappedQIndex = pinnedDashboards.findIndex(x => x.id == id);
        if (mappedQIndex > -1) {
            let updatedQ = [...pinnedDashboards];
            updatedQ[mappedQIndex] = { ...updatedQ[mappedQIndex], expanded: expandedValue };
            setPinnedDashboards(updatedQ);
            return;
        }
        mappedQIndex = unPinnedDashboards.findIndex(x => x.id == id);
        if (mappedQIndex > -1) {
            let updatedQ = [...unPinnedDashboards];
            updatedQ[mappedQIndex] = { ...updatedQ[mappedQIndex], expanded: expandedValue };
            setUnPinnedDashboards(updatedQ);
            return;
        }
    }

    return (
        <>
            {(pinnedDashboards || unPinnedDashboards) && (
                <div className="queuesContainer">
                    <div
                        className="mainHeader"
                        style={{ textDecoration: "none",marginLeft:"2px" }}
                    >
                        Queue Status
                    </div>
                    <div style={{ overflow: "auto", height: "calc(100% - 15px)" }}>
                        {pinnedDashboards.map(c => {
                            return (
                                <QueueDashboard
                                    data={c}
                                    onPinTableChange={onPinTableChange}
                                    onExpandIconClick={hideShowTable}
                                ></QueueDashboard>
                            );
                        })}
                        {unPinnedDashboards.map(c => {
                            return (
                                <QueueDashboard
                                    data={c}
                                    onPinTableChange={onPinTableChange}
                                    onExpandIconClick={hideShowTable}
                                ></QueueDashboard>
                            );
                        })}
                        <br></br>
                    </div>
                </div>
            )}
        </>
    );
}

export default Index;
